(function() {
	'use strict';
	angular.module('app.setup')
		.controller('supplierLateDeliveryIssueForm', supplierLateDeliveryIssueForm);

	supplierLateDeliveryIssueForm.$inject = ['$scope', '$rootScope', '$timeout', '$filter', 'supplierLateDeliveryIssueService', 'storeService', '$experiments'];
	function supplierLateDeliveryIssueForm($scope, $rootScope, $timeout, $filter, supplierLateDeliveryIssueService, storeService, $experiments) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		// view model functions
		vm.supplierLateDeliveryIssue = null;
		vm.action = $scope.action;
		vm.close = close;
		vm.save = save;
		vm.liabilities = [{
			'value': 'Customer',
			'display': adminConfig.customer.name
		    },
		{
		    'value': 'Vendor',
		    'display': 'Vendor'
		}];
		vm.deliveryStatuses = [{
			'value': 'Late',
			'display': 'Late'
		},
		{
			'value': 'Early',
			'display': 'Early'
		}];
		init();
		
		function init() {
			vm.supplierLateDeliveryIssue = {
				liability: 'Customer',
				deliveryStatus: 'Late'
			};
		}

		function save() {
			supplierLateDeliveryIssueService.addLateDeliveryIssue(vm.supplierLateDeliveryIssue, adminConfig.factory.id).then(function (response) {
				if (response.status && response.status >= 200 && response.status < 400) {
					$scope.result('Supplier Delivery Cause added successfully', true);
				} else {
					$scope.result('Error saving Supplier Delivery Cause', false);
				}
			});
		}

		function close() {
			$scope.result('', false);
		}
	}
})();
